module.exports = __webpack_public_path__ + "themes/fq/img/spin-sign.png";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/img/spin-sign.png
// module id = 64
// module chunks = d-game